export default function Footer({ theme }) {
  const { muted, border } = theme;

  return (
    <footer style={{
      padding: "24px 40px",
      borderTop: `1px solid ${border}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 12,
    }}>
      <span style={{ fontSize: 10, color: muted, letterSpacing: "0.12em" }}>
        © 2025 DAVID OLARINDE
      </span>
      <span style={{ fontSize: 10, color: muted, letterSpacing: "0.12em" }}>
        BUILT WITH REACT & TAILWIND
      </span>
    </footer>
  );
}